import { createAction, props } from "@ngrx/store";

import { CustomerType } from "../models/back-in-stock.state";

export const openBackInStock = createAction(
    "[BackInStock] Open Back-in-stock tray",
);

export const resetBackInStock = createAction(
    "[BackInStock] Reset Back-in-stock tray",
);

export const setCustomerType = createAction(
    "[BackInStock] Set customer type",
    props<{ customerType: CustomerType }>(),
);

export const resetCustomerType = createAction(
    "[BackInStock] Reset customer type",
);

export const errorBackInStock = createAction(
    "[BackInStock] Create Subscription Failure",
);

export const successBackInStock = createAction(
    "[BackInStock] Create Subscription Success",
);
